import React, { Component } from 'react';
import { KuposInput, KuposRadio, KuposSelectBox, KuposModalWithButtons } from '../common';
import PropTypes from 'prop-types';
import CommonService from '../../services/commonService';
import ApiUrls from '../../services/apiUrls';
import getIcons from '../themes/functions/getIcons/getIcons';

export default class RefundDetailsBlock extends Component {
  static propTypes = {
    showLoginModal: PropTypes.func,
    onPgChange: PropTypes.func,
    paymentOptions: PropTypes.object,
    metaData: PropTypes.object,
    ticketDetails: PropTypes.object,
    loginData: PropTypes.object,
    onSubmit: PropTypes.func,
    cancelTicket: PropTypes.func,
    onResponse: PropTypes.func,
    t: PropTypes.func,
  };

  bankNames = [];
  accountTypes = [];

  constructor(props) {
    super(props);
    for (let c in this.props.metaData.bank_names) {
      this.bankNames.push({
        value: this.props.metaData.bank_names[c],
        id: this.props.metaData.bank_names[c],
        label: CommonService.capitalize(c),
        name: c,
      });
    }
    for (let c in this.props.metaData.bank_account_types) {
      this.accountTypes.push({
        value: this.props.metaData.bank_account_types[c],
        id: this.props.metaData.bank_account_types[c],
        label: CommonService.capitalize(c),
        name: c,
      });
    }
    this.state = {
      bankForm: {
        name: '',
        nameError: null,
        email: '',
        emailError: '',
        id_card_type: '7',
        id_card_typeError: null,
        id_card_no: '',
        id_card_noError: null,
        bank_name: '',
        bank_nameError: null,
        account_type: '',
        account_typeError: null,
        account_no: '',
        account_noError: null,
        remarks: '',
      },
      paypalForm: {
        name: '',
        nameError: null,
        paypal_email: '',
        paypal_emailError: null,
        paypal_transaction_id: '',
        paypal_transaction_idError: null,
        remarks: '',
      },
      creditCardForm: {
        remarks: '',
      },
    };
  }

  nameChange = text => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        nameError: null,
        name: text,
      },
    });
  };

  lastNameChange = text => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        lastNameError: null,
        lastName: text,
      },
    });
  };

  emailChange = text => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        emailError: null,
        email: text,
      },
    });
  };

  idCardChange = val => {
    //   this.setState({
    //       cardNumberError:null,
    //       idCardNumber:null,
    //       idCardType:val.value
    //   })
  };

  idCardNumberChange = text => {
    if (text) {
      let cardNumber = CommonService.formatRut(text);
      this.setState({
        bankForm: {
          ...this.state.bankForm,
          id_card_noError: null,
          id_card_no: cardNumber,
        },
      });
    } else {
      this.setState({
        bankForm: {
          ...this.state.bankForm,
          id_card_noError: null,
          id_card_no: text,
        },
      });
    }
  };

  bankNameChanged = val => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        bank_nameError: null,
        bank_name: val,
      },
    });
  };

  accountTypeChanged = val => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        account_typeError: null,
        account_type: val,
      },
    });
  };

  accountNoChange = text => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        account_noError: null,
        account_no: CommonService.onlyNumbers(text),
      },
    });
  };
  remarksChange = text => {
    this.setState({
      bankForm: {
        ...this.state.bankForm,
        remarksError: null,
        remarks: text,
      },
    });
  };

  nameChangePaypal = text => {
    this.setState({
      paypalForm: {
        ...this.state.paypalForm,
        nameError: null,
        name: text,
      },
    });
  };
  lastNameChangePaypal = text => {
    this.setState({
      paypalForm: {
        ...this.state.paypalForm,
        lastNameError: null,
        lastName: text,
      },
    });
  };
  emailChangePaypal = text => {
    this.setState({
      paypalForm: {
        ...this.state.paypalForm,
        paypal_emailError: null,
        paypal_email: text,
      },
    });
  };
  idChangePaypal = text => {
    this.setState({
      paypalForm: {
        ...this.state.paypalForm,
        paypal_transaction_idError: null,
        paypal_transaction_id: text,
      },
    });
  };
  remarksChangePaypal = text => {
    this.setState({
      paypalForm: {
        ...this.state.paypalForm,
        remarksError: null,
        remarks: text,
      },
    });
  };

  remarksChangeCreditCard = text => {
    this.setState({
      creditCardForm: {
        ...this.state.creditCardForm,
        remarksError: null,
        remarks: text,
      },
    });
  };

  card4DigitsChangeCreditCard = text => {
    this.setState({
      creditCardForm: {
        ...this.state.creditCardForm,
        digits4Error: null,
        digits4: text,
      },
    });
  };

  onBlur = (text, inp) => {
    if (!text) {
      if (inp == 'name') {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            nameError: {
              message: 'VALIDATIONS.VALID_NAME',
            },
          },
        });
      } else if (inp == 'lastName') {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            lastNameError: {
              message: 'VALIDATIONS.VALID_SURNAME',
            },
          },
        });
      } else if (inp == 'email') {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          },
        });
      } else if (inp == 'card_number') {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            id_card_noError: {
              message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
            },
          },
        });
      } else if (inp == 'account_no') {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            account_noError: {
              message: 'VALIDATIONS.VALID_ACCOUNT_NUMBER',
            },
          },
        });
      }
    } else if (inp == 'email') {
      if (!CommonService.isEMailValid(text)) {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          },
        });
      }
    } else if (inp == 'card_number') {
      if (!CommonService.isRutValid(text)) {
        this.setState({
          bankForm: {
            ...this.state.bankForm,
            id_card_noError: {
              message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
            },
          },
        });
      }
    }
  };

  onBlurPaypal = (text, inp) => {
    if (!text) {
      if (inp == 'name') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            nameError: {
              message: 'VALIDATIONS.VALID_NAME',
            },
          },
        });
      } else if (inp == 'paypal_email') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            paypal_emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          },
        });
      } else if (inp == 'paypal_transaction_id') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            paypal_transaction_idError: {
              message: 'VALIDATIONS.VALID_TRANSACTION',
            },
          },
        });
      }
    } else if (inp == 'paypal_email') {
      if (!CommonService.isEMailValid(text)) {
        this.setState({
          bankForm: {
            ...this.state.paypalForm,
            paypal_emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          },
        });
      }
    }
  };

  onBlurCreditCard = (text, inp) => {
    if (!text) {
      if (inp == 'name') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            nameError: {
              message: 'VALIDATIONS.VALID_NAME',
            },
          },
        });
      } else if (inp == 'lastName') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            lastNameError: {
              message: 'VALIDATIONS.VALID_SURNAME',
            },
          },
        });
      } else if (inp == 'email') {
        this.setState({
          paypalForm: {
            ...this.state.paypalForm,
            paypal_emailError: {
              message: 'VALIDATIONS.VALID_EMAIL',
            },
          },
        });
      }
    } else if (inp == 'email') {
      if (!CommonService.isEMailValid(text)) {
        this.setState({
          bankForm: {
            ...this.state.paypalForm,
            paypal_emailError: {
              message: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
            },
          },
        });
      }
    }
  };

  isValid = () => {
    let errorCount = 0;
    let bankForm = CommonService.copyObject(this.state.bankForm);
    if (!this.state.bankForm.name) {
      bankForm = {
        ...bankForm,
        nameError: {
          message: 'VALIDATIONS.VALID_NAME',
        },
      };
      errorCount++;
    }

    if (!this.state.bankForm.lastName) {
      bankForm = {
        ...bankForm,
        lastNameError: {
          message: 'VALIDATIONS.VALID_SURNAME',
        },
      };
      errorCount++;
    }
    if (!this.state.bankForm.email) {
      bankForm = {
        ...bankForm,
        emailError: {
          message: 'VALIDATIONS.VALID_EMAIL',
        },
      };
      errorCount++;
    } else if (!CommonService.isEMailValid(this.state.bankForm.email)) {
      bankForm = {
        ...bankForm,
        emailError: {
          message: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
        },
      };
      errorCount++;
    }
    if (!this.state.bankForm.bank_name) {
      bankForm = {
        ...bankForm,
        bank_nameError: {
          message: 'VALIDATIONS.VALID_BANK',
        },
      };
      errorCount++;
    }
    if (!this.state.bankForm.account_type) {
      bankForm = {
        ...bankForm,
        account_typeError: {
          message: 'VALIDATIONS.VALID_BANK_ACCOUNT',
        },
      };
      errorCount++;
    }
    if (!this.state.bankForm.account_no) {
      bankForm = {
        ...bankForm,
        account_noError: {
          message: 'VALIDATIONS.VALID_BANK_ACCOUNT',
        },
      };
      errorCount++;
    }
    if (!this.state.bankForm.id_card_no) {
      bankForm = {
        ...bankForm,
        id_card_noError: {
          message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
        },
      };
      errorCount++;
    } else if (!CommonService.isRutValid(this.state.bankForm.id_card_no)) {
      bankForm = {
        ...bankForm,
        id_card_noError: {
          message: 'VALIDATIONS.VALID_RUT',
        },
      };
      errorCount++;
    }
    if (errorCount <= 0) {
      return true;
    }
    this.setState({
      bankForm: bankForm,
    });
    return false;
  };

  isValidCreditCard = () => {
    if (!this.state.creditCardForm.digits4 || this.state.creditCardForm.digits4.length !== 4) {
      this.setState({
        creditCardForm: {
          ...this.state.creditCardForm,
          digits4Error: { message: 'Últimos 4 dígitos de la tarjeta de crédito' },
        },
      });
      return false;
    }
    return true;
  };

  isValidPaypal = () => {
    let errorCount = 0;
    let paypalForm = CommonService.copyObject(this.state.paypalForm);
    if (!this.state.paypalForm.name) {
      paypalForm = {
        ...paypalForm,
        nameError: {
          message: 'VALIDATIONS.VALID_EMAIL',
        },
      };
      errorCount++;
    }
    if (!this.state.paypalForm.paypal_email) {
      paypalForm = {
        ...paypalForm,
        paypal_emailError: {
          message: 'VALIDATIONS.VALID_EMAIL',
        },
      };
      errorCount++;
    } else if (!CommonService.isEMailValid(this.state.paypalForm.paypal_email)) {
      paypalForm = {
        ...paypalForm,
        paypal_emailError: {
          message: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
        },
      };
      errorCount++;
    }
    if (!this.state.paypalForm.paypal_transaction_id) {
      paypalForm = {
        ...paypalForm,
        paypal_transaction_idError: {
          message: 'VALIDATIONS.VALID_BANK',
        },
      };
      errorCount++;
    }
    if (errorCount <= 0) {
      return true;
    }
    this.setState({
      paypalForm: paypalForm,
    });
    return false;
  };

  cancelWithCashRefund = (type, path) => {
    if (type == 2) {
      // if (!this.isValid()) {
      //   return;
      // }
      this.cashRefundConfirm(path);
    } else if (type == 3) {
      // if (!this.isValidPaypal()) {
      //   return;
      // }
      this.paypalRefunConfirm(path);
    } else if (type == 7) {
      // if (!this.isValidPaypal()) {
      //   return;
      // }
      this.creditCardRefunConfirm(path);
    }
    // this.setState({
    //   showModal: true,
    //   modalTitle: '¿Estás seguro que deseas cancelar tu pasaje?',
    //   buttonText1: 'CONFIRMAR',
    //   showButton2: true,
    //   buttonText2: 'VOLVER',
    //   onButtonClick1: type == 2 ? () => this.cashRefundConfirm(path) : () => this.paypalRefunConfirm(path),
    // });
  };

  cancelTicketApiCall = (data, path) => {
    let pathObj = CommonService.queryToObject(path);
    let paramData = { ...data, ...pathObj };
    let dataEnc = CommonService.createJwtFullAndEncrypt(paramData, '@kup' + 'os@');
    console.log(paramData);
    this.props
      .cancelTicket({
        url: ApiUrls.cancelTicketV3(path),
        data: {
          token: dataEnc,
        },
      })
      .then(res => {
        console.log({ res });
        if (res && res.data && res.data.token) {
          let data = CommonService.decryptAndParse(res.data.token, '@kup' + 'os@');
          console.log({ data });
          res = data;

          const operator = this.props.operator;

          if (operator && operator.operator_name && operator.operator_name.includes("andimar")) {
            window.dataLayer.push({
              'event': 'formAnulacion',
            });

          }
        }
        this.props.onResponse({ data: res });
      });
  };

  cashRefundConfirm = path => {
    let paramData = {};
    let data = {
      name: this.state.bankForm.name,
      email: this.state.bankForm.email,
      id_card_type: '7',
      id_card_no: this.state.bankForm.id_card_no,
      bank_name: this.state.bankForm.bank_name.value,
      account_type: this.state.bankForm.account_type.value,
      account_no: this.state.bankForm.account_no,
      remarks: '',
    };
    paramData = { account_details: data };
    // this.props.cancelTicket({
    //   callback: result => this.onCashRefund(result),
    //   path: this.props.path,
    //   data: paramData,
    // });

    this.cancelTicketApiCall(paramData, path);
    // this.props.cancelTicket({ url: ApiUrls.cancelTicket(path), data: paramData }).then(res => {
    //   this.props.onResponse(res);
    // });
  };

  paypalRefunConfirm = path => {
    let paramData = {};
    let data = {
      name: this.state.paypalForm.name,
      paypal_email: this.state.paypalForm.paypal_email,
      paypal_transaction_id: this.state.bankForm.paypal_transaction_id,
      remarks: this.state.bankForm.remarks,
    };
    paramData = { paypal_details: data };
    // this.props.cancelTicket({
    //   callback: result => this.onCashRefund(result),
    //   path: this.props.path,
    //   data: paramData,
    // });
    this.cancelTicketApiCall(paramData, path);
    // this.props.cancelTicket({ url: ApiUrls.cancelTicket(path), data: paramData }).then(res => {
    //   this.props.onResponse(res);
    // });
  };

  creditCardRefunConfirm = path => {
    let paramData = {};
    let data = {
      remarks: this.state.creditCardForm.remarks,
      email: this.props.ticketDetails.seat_Details
        ? this.props.ticketDetails.seat_Details.contact_details.email
        : '',
    };
    paramData = { credit_card_details: data };
    // this.props.cancelTicket({
    //   callback: result => this.onCashRefund(result),
    //   path: this.props.path,
    //   data: paramData,
    // });
    this.cancelTicketApiCall(paramData, path);
    // this.props.cancelTicket({ url: ApiUrls.cancelTicket(path), data: paramData }).then(res => {
    //   this.props.onResponse(res);
    // });
  };

  onCashRefund = result => {
    if (result.data && result.data.error) {
      this.refs.toast.show(result.data.error);
      this.setState({
        showModal: true,
        modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
        button1Text: 'VOLVER',
        modalBody: result.data.error,
        button1Press: this.closeModal,
        showButton2: false,
        button2Text: null,
        modalChild: null,
        // modalIcon: require('../../assets/icons/cross-grey.png'),
      });
    } else if (result.data && !result.data.success && result.data.body) {
      this.setState({
        showModal: true,
        modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
        button1Text: 'VOLVER',
        modalBody: result.data.body.message,
        button1Press: this.closeModal,
        showButton2: false,
        button2Text: null,
        modalChild: null,
        // modalIcon: require('../../assets/icons/cross-grey.png'),
      });
    } else if (result.data && result.data.success && result.data.body) {
      // this.closeModal();
      // Navigation.push(this.props.componentId, {
      //   component: {
      //     name: CANCEL_SUCCESS_SCREEN,
      //     passProps: { cancel_ticket: result.data.body.cancel_ticket, screenType: 2 },
      //     options: {
      //       topBar: {
      //         title: {
      //           text: 'Anular Pasaje',
      //           fontFamily: Platform.OS === 'android' ? 'Carnas Regular' : 'Carnas-Regular',
      //           alignment: 'center',
      //         },
      //         rightButtons: {
      //           id: 'rightHomeButton',
      //           icon: require('../../assets/icons/home-icon.png'),
      //         },
      //         leftButtons: [{}],
      //       },
      //     },
      //   },
      // });
    }
  };

  onPgChange = id => {
    if (id == 1) {
      if (CommonService.isLoggedIn(this.props.loginData)) {
        let state = {
          pbCashSelected: !this.props.paymentOptions.pbCashSelected,
          bankSelected: false,
          paypalSelected: false,
          couponSelected: false,
          creditCardSelected: false,
        };
        this.props.onPgChange(state);
      } else {
        this.props.openCloseLoginModal(true);
      }
    } else if (id == 2) {
      let state = {
        pbCashSelected: false,
        bankSelected: !this.props.paymentOptions.bankSelected,
        paypalSelected: false,
        couponSelected: false,
        creditCardSelected: false,
      };
      this.props.onPgChange(state);
    } else if (id == 3) {
      let state = {
        pbCashSelected: false,
        bankSelected: false,
        paypalSelected: !this.props.paymentOptions.paypalSelected,
        couponSelected: false,
        creditCardSelected: false,
      };
      this.props.onPgChange(state);
    } else if (id == 4) {
      let state = {
        pbCashSelected: false,
        bankSelected: false,
        paypalSelected: false,
        couponSelected: !this.props.paymentOptions.couponSelected,
        creditCardSelected: false,
      };
      this.props.onPgChange(state);
    } else if (id == 5) {
      let state = {
        pbCashSelected: false,
        bankSelected: false,
        paypalSelected: false,
        couponSelected: false,
        creditCardSelected: !this.props.paymentOptions.creditCardSelected,
      };
      this.props.onPgChange(state);
    }
  };

  openLoginModal = () => {
    // this.props.actions.openCloseLoginModal(true);
  };

  render() {
    const { t } = this.props;
    const { ticketDetails, paymentOptions, metaData, operator, decryptedData } = this.props;
    console.log({ operator })
    // const isChangeTicket =
    //   decryptedData && decryptedData.split('is_change_ticket=')[1] == 'true' ? true : false;
    const isChangeTicket = localStorage.getItem('isChangeTicket') == 'true' ? true : false;
    return (
      <div className="cancellation-refund-details-block">
        <div className="bank-deposit-heading font13">
          {t('CANCEL_TICKET.SELECT_TYPE_OF_REFUND.NORMAL')}
          <span className="bold-text ">{t('CANCEL_TICKET.SELECT_TYPE_OF_REFUND.BOLD')}</span>
        </div>
        <div className="flex-row payment-methods font10 bold-text">
          {!isChangeTicket &&
            ticketDetails.pg_type != 39 &&
            ticketDetails.pg_type == 23 &&
            ticketDetails.pg_type !== 0 ? (
            <div className="kupos-payment-method kupos-payment-method-bank-deposit flex-row">
              <KuposRadio
                onChange={() => this.onPgChange(3)}
                checked={paymentOptions && paymentOptions.paypalSelected}
              />
              <img src="/static/images/paypal_logo.png" alt="" />
            </div>
          ) : null}
          {!isChangeTicket &&
            ticketDetails.pg_type != 39 &&
            ticketDetails.pg_type != 40 &&
            ticketDetails.pg_type != 23 &&
            ticketDetails.pg_type !== 0 &&
            ticketDetails.card_type !== 'credit' ? (
            <div className="kupos-payment-method kupos-payment-method-bank-deposit flex-row">
              <KuposRadio
                onChange={() => this.onPgChange(2)}
                checked={paymentOptions && paymentOptions.bankSelected}
                label="CANCEL_TICKET.BANK_DEPOSIT"
                t={t}
              />
            </div>
          ) : null}
          {!isChangeTicket &&
            ticketDetails.pg_type != 41 &&
            ticketDetails.pg_type != 39 &&
            ticketDetails.pg_type != 23 &&
            ticketDetails.pg_type !== 0 &&
            ticketDetails.card_type === 'credit' ? (
            <div className="kupos-payment-method kupos-payment-method-bank-deposit flex-row">
              <KuposRadio
                onChange={() => this.onPgChange(5)}
                checked={paymentOptions && paymentOptions.creditCardSelected}
                label={t('CANCEL_TICKET.CREDIT_CARD')}
              />
            </div>
          ) : null}
          {/* {operator && operator.operator_name && operator.operator_name == 'cormarbus' && CommonService.isLoggedIn() ? ( */}
          {operator && operator.is_pay_enabled ? (
            <div className="kupos-payment-method kupos-payment-method-bank-deposit flex-row">
              <KuposRadio
                onChange={() => this.onPgChange(1)}
                checked={paymentOptions && paymentOptions.pbCashSelected}
              />
              <img
                // src={getIcons('operatorPay',operator)}
                src={operator.wallet_logo}
                style={{ width: '100%',height:"45px" }}
                alt=""
                onClick={() => this.onPgChange(1)}
              />
              {/* <span className="primary-text">&nbsp; {t('CANCEL_TICKET.NO_ADDITIONAL_COST')}</span> */}
            </div>
          ) : null}
        </div>

        {paymentOptions && paymentOptions.paypalSelected ? (
          <div>
            <div className="subsection-card-sections bold-text label-row">
              <span>{t('CANCEL_TICKET.NAME')}</span>
              <span>{t('CANCEL_TICKET.SURNAME')}</span>
              <span>{t('CANCEL_TICKET.TRANSACTION_ID')}</span>
              <span>{t('CANCEL_TICKET.EMAIL_ID')}</span>
            </div>
            <div className="subsection-card-sections print-ticket-input">
              <span className="first-name-input">
                <KuposInput
                  type="text"
                  className="kupos-border"
                  value={this.state.paypalForm.name}
                  error={this.state.paypalForm.nameError ? true : false}
                  errorMessage={
                    this.state.paypalForm.nameError ? this.state.paypalForm.nameError.message : ''
                  }
                  onChange={this.nameChangePaypal}
                  onBlur={text => this.onBlurPaypal(text, 'name')}
                />
              </span>
              <span className="last-name-input">
                <KuposInput
                  type="text"
                  className="kupos-border"
                  value={this.state.paypalForm.lastName}
                  error={this.state.paypalForm.lastNameError ? true : false}
                  errorMessage={
                    this.state.paypalForm.lastNameError
                      ? this.state.paypalForm.lastNameError.message
                      : ''
                  }
                  onChange={this.lastNameChangePaypal}
                  onBlur={text => this.onBlurPaypal(text, 'lastName')}
                />
              </span>
              <span className="paypal-input">
                <KuposInput
                  type="text"
                  className="kupos-border"
                  placeholder="XXXXXXXXXXXXXX"
                  value={this.state.paypalForm.paypal_transaction_id}
                  error={this.state.paypalForm.paypal_transaction_idError ? true : false}
                  errorMessage={
                    this.state.paypalForm.paypal_transaction_idError
                      ? this.state.paypalForm.paypal_transaction_idError.message
                      : ''
                  }
                  onChange={this.idChangePaypal}
                  onBlur={text => this.onBlurPaypal(text, 'paypal_transaction_id')}
                />
              </span>

              <span className="email-input">
                <KuposInput
                  type="email"
                  className="kupos-border"
                  value={this.state.paypalForm.paypal_email}
                  error={this.state.paypalForm.paypal_emailError ? true : false}
                  errorMessage={
                    this.state.paypalForm.paypal_emailError
                      ? this.state.paypalForm.paypal_emailError.message
                      : ''
                  }
                  onChange={this.emailChangePaypal}
                  onBlur={text => this.onBlurPaypal(text, 'paypal_email')}
                />
              </span>
            </div>
          </div>
        ) : null}

        {paymentOptions && paymentOptions.creditCardSelected ? (
          <div>
            <div className=" mb5 bold-text label-row font10">
              <span>{t('Últimos 4 dígitos de la tarjeta de crédito')}</span>
            </div>
            <div className=" print-ticket-input digit4-card-inp">
              <span className="first-name-input">
                <KuposInput
                  type="number"
                  className="kupos-border"
                  value={this.state.creditCardForm.digits4}
                  error={this.state.creditCardForm.digits4Error ? true : false}
                  errorMessage={
                    this.state.creditCardForm.digits4Error
                      ? this.state.creditCardForm.digits4Error.message
                      : ''
                  }
                  onChange={this.card4DigitsChangeCreditCard}
                />
              </span>
            </div>

            <div className="subsection-card-sections  bold-text label-row">
              <span className="font10">{t('CANCEL_TICKET.REFUND_COMMENTS')}</span>
            </div>
            <div className="">
              <span className="email-input">
                <KuposInput
                  type="text"
                  className="kupos-border"
                  value={this.state.creditCardForm.remarks}
                  onChange={this.remarksChangeCreditCard}
                />
              </span>
            </div>
          </div>
        ) : null}

        {paymentOptions && paymentOptions.bankSelected ? (
          <div className="font9 inputs-container">
            <div className="subsection-card-sections bold-text label-row">
              <span>{t('CANCEL_TICKET.NAME')}</span>
              <span>{t('CANCEL_TICKET.SURNAME')}</span>
              <span>RUT</span>
              <span>{t('CANCEL_TICKET.EMAIL_ID')}</span>
              <span>{t('CANCEL_TICKET.BANK')}</span>
              <span>{t('CANCEL_TICKET.ACC_TYPE')}</span>
              <span>{t('CANCEL_TICKET.ACC_NUM')}</span>
            </div>
            <div className="subsection-card-sections print-ticket-input">
              <span className="first-name-input">
                <KuposInput
                  type="default"
                  className="kupos-border"
                  value={this.state.bankForm.name}
                  error={this.state.bankForm.nameError ? true : false}
                  errorMessage={
                    this.state.bankForm.nameError ? this.state.bankForm.nameError.message : ''
                  }
                  onChange={this.nameChange}
                  onBlur={text => this.onBlur(text, 'name')}
                />
              </span>
              <span className="last-name-input">
                <KuposInput
                  type="default"
                  className="kupos-border"
                  value={this.state.bankForm.lastName}
                  error={this.state.bankForm.lastNameError ? true : false}
                  errorMessage={
                    this.state.bankForm.lastNameError
                      ? this.state.bankForm.lastNameError.message
                      : ''
                  }
                  onChange={this.lastNameChange}
                  onBlur={text => this.onBlur(text, 'lastName')}
                />
              </span>
              <span className="card-number-input">
                <KuposInput
                  type="default"
                  className="kupos-border"
                  placeholder="XXXXXXXXXXXXXX"
                  value={this.state.bankForm.id_card_no}
                  error={this.state.bankForm.id_card_noError ? true : false}
                  errorMessage={
                    this.state.bankForm.id_card_noError
                      ? this.state.bankForm.id_card_noError.message
                      : ''
                  }
                  onChange={this.idCardNumberChange}
                  onBlur={text => this.onBlur(text, 'card_number')}
                />
              </span>
              <span className="email-input">
                <KuposInput
                  type="email"
                  className="kupos-border"
                  value={this.state.bankForm.email}
                  error={this.state.bankForm.emailError ? true : false}
                  errorMessage={
                    this.state.bankForm.emailError ? this.state.bankForm.emailError.message : ''
                  }
                  onChange={this.emailChange}
                  onBlur={text => this.onBlur(text, 'email')}
                />
              </span>
              <span className="bank-name-input">
                <KuposSelectBox
                  smallArrow={true}
                  height={42}
                  noPaddingLeft={true}
                  error={this.state.bankForm.bank_nameError ? true : false}
                  errorMessage={
                    this.state.bankForm.bank_nameError
                      ? this.state.bankForm.bank_nameError.message
                      : ''
                  }
                  selectedOption={t(this.state.bank_name)}
                  options={this.bankNames}
                  onChange={this.bankNameChanged}
                  styleClass={'common-kupos-select-box-cancellation'}
                  t={t}
                />
              </span>
              <span className="bank-type-input">
                <KuposSelectBox
                  smallArrow={true}
                  height={42}
                  noPaddingLeft={true}
                  error={this.state.bankForm.account_typeError ? true : false}
                  errorMessage={
                    this.state.bankForm.account_typeError
                      ? this.state.bankForm.account_typeError.message
                      : ''
                  }
                  selectedOption={t(this.state.account_type)}
                  options={this.accountTypes}
                  onChange={this.accountTypeChanged}
                  styleClass={'common-kupos-select-box-cancellation'}
                  t={t}
                />
              </span>
              <span className="accoun-number-input">
                <KuposInput
                  type="number"
                  className="kupos-border"
                  value={this.state.bankForm.account_no}
                  error={this.state.bankForm.account_noError ? true : false}
                  errorMessage={
                    this.state.bankForm.account_noError
                      ? this.state.bankForm.account_noError.message
                      : ''
                  }
                  onChange={this.accountNoChange}
                  onBlur={text => this.onBlur(text, 'account_no')}
                />
              </span>
            </div>
            <div className="subsection-card-sections  bold-text label-row">
              <span>{t('CANCEL_TICKET.REFUND_COMMENTS')}</span>
            </div>
            <div className="">
              <span className="remarks-input">
                <KuposInput
                  type="text"
                  className="kupos-border"
                  value={this.state.bankForm.remarks}
                  onChange={this.remarksChange}
                />
              </span>
            </div>
          </div>
        ) : null}

        <KuposModalWithButtons
          showModal={this.state.showModal}
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={this.state.onButtonClick1 ? this.state.onButtonClick1 : this.closeModal}
          showButton2={this.state.showButton2}
          buttonText2={this.state.buttonText2}
          onButtonClick2={this.state.onButtonClick2 ? this.state.onButtonClick2 : this.closeModal}
          icon={this.state.modalIcon}
          buttonTextStyle={{ fontSize: 15 }}
          // showCloseIcon={this.state.showCloseIcon}
          // closeIconPress={this.closeModal}
          onHide={this.closeModal}
          operator={operator}
        ></KuposModalWithButtons>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/cancellation/RefundDetailsBlock.js